import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { LotModel } from '../../model/auction.model';

@Component({
  selector: 'app-bid-confirmation-dialog',
  templateUrl: './bid-confirmation-dialog.component.html',
  styleUrls: ['./bid-confirmation-dialog.component.scss']
})
export class BidConfirmationDialogComponent implements OnInit {

  @Input() lot: LotModel;
  @Input() bidAmount: number;

  constructor(public ref: NbDialogRef<BidConfirmationDialogComponent>) { }

  ngOnInit(): void {
  }

  public confirm(): void {
    this.ref.close(true);
  }

  public cancel(): void {
    this.ref.close(false);
  }

}

